import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

import { useUser, usePopup, useData, useMenu, useLang, useLoading } from "../zustand/store.js";

import { LangText } from "../zustand/dict.js";
// import { lang } from '../utils/utils';
import consts from '../libs/consts';
import images from "../libs/images"
import InputFileDrag from '../components/InputFileDrag';
import InputSimple from '../components/InputSimple.js';
import Button from '../components/Button';
import Selector from '../components/Selector';
import RadioImage from "../components/RadioImage";
import Radio from "../components/Radio";
import InputRange from "../components/InputRange";
import * as APIS from '../utils/service.js'
import Modal from "../components/Modal.js";
import axios from "axios";
import { loadImage } from "../utils/utils.js";

/**
 * 이미지 확장하기
 */
export default function Menu6() {
    const navigate = useNavigate();
    const location = useLocation();

    const { isLoading, setLoading } = useLoading();
    const { menu, getMenu } = useMenu();
    const { country, getLang } = useLang();
    const { bears, token, options, isReload, reload, setData, addABear } = useUser();
    const { open, title, popOpen, popClose } = usePopup();
    const [modal, setModal] = useState(consts.defaultModalValue)

    const [config, setConifg] = useState({});
    const [configError, setConfigError] = useState(false);

    const [photo, setPhoto] = useState(null);
    const [layout, setLayout] = useState(null);
    const [mulSlide, setMulSlide] = useState(50);

    const [share, setShare] = useState(false);

    const [controller, setcontroller] = useState(null)

    const makeImageFunc = () => {
        // navigate("/myart_history");

        let sendData = {
            photo: photo,
            layout: layout,
            multiple: 0,
            share: share
        }

        if (!photo) {
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: "error_input_photo" })
            })
            return
        }

        sendData.multiple = Number(mulSlide)

        console.log("sendData", sendData);

        setLoading(true);
        // setTimeout(() => {
        //     setLoading(false);
        //     // navigate("/myart_history")
        // }, 1000)
        // return;
        APIS.post("/aiImage/enlarge", sendData).then(({ data }) => {
            if (data) console.log("/aiImage/generator:", data);
            setLoading(false);
            reload();
            navigate("/myart_history")
        }).catch((result) => {
            setLoading(false);
            let data = result.response.data;
            console.log(data, getLang({ key: data.msgkey }));
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: data.msgkey })
            })
        })
    }

    const defaultSetOption = (configData) => {
        let error = false

        if ("option_selector_layout" in configData) {
            setLayout(configData.option_selector_layout[0].idx)
        } else {
            error = true
        }

        if ("option_slide" in configData) {
            setMulSlide(configData.option_slide.multi?.default)
        } else {
            error = true
        }
        if (error) setConfigError(error)

        if (location.state?.artData) {
            setLoading(true)
            setTimeout(() => {
                setLoading(false)
                setLoadFunc(location.state?.artData, configData)
            }, 1000)
        }
    }

    const setLoadFunc = async (artData, configData) => {
        console.log("다시만들기")
        console.log("🚀 ~ setLoadPrec ~ artData:", artData)

        if (artData?.photoFile) {
            let imageData = await loadImage(consts.imgUrl + artData?.photoFile)
            setPhoto(imageData)
        }

        if (artData?.layoutOption) {
            let data = configData?.option_selector_layout?.find(v => v.value == artData?.layoutOption)
            if (data) {
                setLayout(data.idx);
            }
        }
        if (artData?.multipleOption) {
            setMulSlide(artData?.multipleOption)
        }
    }

    const configDataFunc = () => {
        APIS.post('/config/option').then(({ data }) => {
            setConifg(data);
            defaultSetOption(data);
        }).catch((e) => {
            console.log(e.response);
        });
    }

    useEffect(() => {
        configDataFunc();
    }, [])



    const modalConfirm = () => {
        if (modal.type === "test") {

        } else {
            modalClose();
        }
    }

    const modalClose = () => {
        setModal(consts.defaultModalValue)
    }

    return (
        <>
            <Modal
                open={modal.open}
                setOpen={(v) => {
                    setModal({ ...modal, open: v })
                }}
                title={modal.title}
                message={modal.message}
                onConfirm={modalConfirm}
                onCancel={modal.isClose ? () => { modalClose(); } : null}
            />

            <div className="content">
                <div className="title_box3">
                    <div className="text_area">
                        <p className="title">
                            <LangText id={getMenu({ idx: 6 }).title_key} />
                        </p>
                        <p className="sub_title">
                            <LangText id={getMenu({ idx: 6 }).info_key} />
                        </p>
                    </div>
                    <div className="thumb">
                        {/* <img src={consts.imgUrl + getMenu({ idx: 6 })?.image?.ko} /> */}
                        <img src={consts.imgUrl + getMenu({ idx: 6 })?.image?.[country]} />
                    </div>
                </div>

                <div className="setting_box">
                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_upload_work_image" /></p>
                                <p className="body1"><LangText id="info_upload_work_image" /></p>
                            </div>
                        </div>

                        <InputFileDrag
                            name="drag-file"
                            value={photo}
                            setValue={setPhoto}
                        />
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_expansion_area" /></p>
                            </div>
                        </div>
                        <Radio
                            value={layout}
                            setValue={setLayout}
                            options={config.option_selector_layout?.map((v) => {
                                return { value: v.idx, label: getLang({ key: v?.title_key }) }
                            })} />
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_expansion_scale" /></p>
                                <p className="body1"><LangText id="info_expansion_scale" /></p>
                            </div>
                        </div>

                        <InputRange
                            className="mt-24"
                            startText={"1.25"}
                            endText={"2.0"}
                            step={config.option_slide?.multi?.step}
                            min={config.option_slide?.multi?.min || 0}
                            max={config.option_slide?.multi?.max || 100}
                            value={mulSlide}
                            setValue={setMulSlide}
                            tickerValue={mulSlide}
                        />
                    </div>
                </div>

                <div className="confirm_box mt-80">
                    <Button
                        type={4}
                        title={getLang({ key: "btn_create_image", replace: { key: "{0}", val: getMenu({ idx: 6 })?.point } })}
                        round
                        onClick={makeImageFunc}
                    />
                    <input
                        type="checkbox"
                        id={"checkShare"}
                        className='checkbox5'
                        checked={share}
                        onChange={(e) => {
                            setShare(e.target.checked)
                        }} />
                    <label className="mt-12" for={'checkShare'}>
                        <LangText id="btn_not_share" />
                    </label>
                </div>
            </div>
        </>
    );
}
